import { graphql, useStaticQuery } from 'gatsby';

// Better to have a list of common queries in one place than to have the same query repeated in multiple components.
// This also allows us to use the query in providers and pass the data down via context, which is better for performance than having multiple components all run the same query with useStaticQuery.
export const useNeighborhoodsQuery = () => {
    const data = useStaticQuery(graphql`
{
    allBeachNeighborhood(
        filter: {approved: {eq: true}, archived: {eq: false}, deleted: {eq: false}}
        sort: {sort: ASC}
    ) {
        edges {
            node {
                id
                name
                headerImage
                featuredDescription
                permalink
                uri
                relatedImage
                RelatedNeighborhood1 {
                  object {
                    relatedImage
                    uri
                    name
                  }
                }
                RelatedNeighborhood2 {
                  object {
                    relatedImage
                    uri
                    name
                  }
                }
            }
        }
    }
}
`);
    return { data };
};